import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from './assets/app.png'


const _hoisted_1 = { id: "app" }
const _hoisted_2 = { class: "w3-top w3-bar w3-theme-d4" }
const _hoisted_3 = { class: "w3-left" }
const _hoisted_4 = {
  type: "button",
  class: "w3-bar-item w3-button w3-xlarge w3-hover-theme",
  "aria-label": "Add"
}
const _hoisted_5 = { class: "w3-right" }
const _hoisted_6 = { href: "https://gitlab.com/javier-sedano/kubos" }
const _hoisted_7 = {
  type: "button",
  class: "w3-bar-item w3-button w3-xlarge w3-hover-theme",
  "aria-label": "Contact"
}
const _hoisted_8 = { href: "https://jsedano.duckdns.org/contact.html" }
const _hoisted_9 = {
  type: "button",
  class: "w3-bar-item w3-button w3-xlarge w3-hover-theme",
  "aria-label": "Source"
}
const _hoisted_10 = /*#__PURE__*/_createElementVNode("img", {
  class: "w3-circle app-header-image",
  src: _imports_0,
  alt: "app"
}, null, -1)
const _hoisted_11 = { class: "w3-padding w3-text-theme w3-display-container app-main-content" }
const _hoisted_12 = { class: "w3-container w3-bottom w3-theme-d4 w3-margin-top w3-bar" }
const _hoisted_13 = { class: "w3-left app-footer-version" }
const _hoisted_14 = { class: "w3-right app-footer-copyright" }
const _hoisted_15 = /*#__PURE__*/_createElementVNode("a", { href: "https://creativecommons.org/licenses/by-sa/4.0/legalcode" }, "CC-BY-SA-4.0", -1)

import { onMounted, ref } from "vue";
import { library } from "@fortawesome/fontawesome-svg-core";
import {
  faCopyright,
  faPlus,
  faEnvelope,
} from "@fortawesome/free-solid-svg-icons";
import {
  faCreativeCommons,
  faCreativeCommonsBy,
  faCreativeCommonsSa,
  faGitlab,
} from "@fortawesome/free-brands-svg-icons";
import { versionService } from "./services/version.service";
import ErrorRender from "./components/ErrorRender.vue"; // NOSONAR


export default /*#__PURE__*/_defineComponent({
  __name: 'App',
  setup(__props) {

library.add(
  faCopyright,
  faPlus,
  faEnvelope,
  faCreativeCommons,
  faCreativeCommonsBy,
  faCreativeCommonsSa,
  faGitlab
);

const version = ref("");

onMounted(async () => {
  version.value = await versionService.getVersion();
});

return (_ctx: any,_cache: any) => {
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("header", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_router_link, { to: "/" }, {
          default: _withCtx(() => [
            _createElementVNode("button", _hoisted_4, [
              _createVNode(_component_font_awesome_icon, {
                icon: ['fas', 'plus'],
                "aria-hidden": "true"
              })
            ])
          ]),
          _: 1
        })
      ]),
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("a", _hoisted_6, [
          _createElementVNode("button", _hoisted_7, [
            _createVNode(_component_font_awesome_icon, {
              icon: ['fab', 'gitlab'],
              "aria-hidden": "true"
            })
          ])
        ]),
        _createElementVNode("a", _hoisted_8, [
          _createElementVNode("button", _hoisted_9, [
            _createVNode(_component_font_awesome_icon, {
              icon: ['fas', 'envelope'],
              "aria-hidden": "true"
            })
          ])
        ]),
        _createVNode(_component_router_link, { to: "/" }, {
          default: _withCtx(() => [
            _hoisted_10
          ]),
          _: 1
        })
      ])
    ]),
    _createVNode(ErrorRender),
    _createElementVNode("div", _hoisted_11, [
      _createVNode(_component_router_view)
    ]),
    _createElementVNode("footer", _hoisted_12, [
      _createElementVNode("div", _hoisted_13, " Version " + _toDisplayString(version.value), 1),
      _createElementVNode("div", _hoisted_14, [
        _createVNode(_component_router_link, { to: "/privacy" }, {
          default: _withCtx(() => [
            _createTextVNode("Privacy")
          ]),
          _: 1
        }),
        _createVNode(_component_font_awesome_icon, { icon: ['fas', 'copyright'] }),
        _createTextVNode("Javier Sedano 2020-2025, "),
        _createVNode(_component_font_awesome_icon, { icon: ['fab', 'creative-commons'] }),
        _createVNode(_component_font_awesome_icon, { icon: ['fab', 'creative-commons-by'] }),
        _createVNode(_component_font_awesome_icon, { icon: ['fab', 'creative-commons-sa'] }),
        _hoisted_15
      ])
    ])
  ]))
}
}

})